export const environment = {
  production: true,
  version: require('../../../../package.json').version,
  versionDate: '2026/05/27',
  api: 'https://server-configurateur.depagne.fr/api',
  hideClientInscription: false,
  showAdminPageFeatures: true,
  lastCguUpdate: '2024-06-16T14:47:36.466Z',
};
